import $ from 'jquery';
import getDefaultLineState from './get_line_state';

function handleLastLine(appState, state, imageDataItems, callback, defaultConfig) {
  const hasRemainingImages = state.lastIndex < state.dataSize - 1 && state.lineCount > 0;
  if (!hasRemainingImages) {
    return;
  }

  const hasOnlyOnePageVolume = appState.isImageDataEnd && appState.dataPageNum === 1;
  const lastLine = getLastLine(imageDataItems, state.lineCount);
  setDataLineCount(lastLine, state);

  if (hasOnlyOnePageVolume) {
    const lastLineState = getDefaultLineState();
    $.each(lastLine, (idx, data) => {
      if (data.w >= defaultConfig.fixedImageDivWidth) {
        lastLineState.accImageWidth += data.w;
      } else {
        lastLineState.accImageWidth += (defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin);
        lastLineState.widthFixedCount++;
      }

      lastLineState.accImageHeight += data.h;

      if (lastLineState.minImageHeight > data.h) {
        lastLineState.minImageHeight = data.h;
      }

      if (lastLineState.maxImageHeight < data.h) {
        lastLineState.maxImageHeight = data.h;
      }
    });

    state.lineCount++;
    state.isSingleLine = true;
    callback(lastLine, state, lastLineState);
  } else {
    hideThumbnails(lastLine);
  }
}

function getLastLine(imageDataItems) {
  return $.map(imageDataItems, (image) => {
    return image.isInLastLine ? image : null;
  });
}

function hideThumbnails(thumbs) {
  $.each(thumbs, (idx, data) => {
    data.hide = 'Y';
  });
}

function setDataLineCount(thumbs, state) {
  $.each(thumbs, (idx, data) => {
    data.lineCount = state.lineCount + 1;
  });
}

export default handleLastLine;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/image_calculator/handle_last_line.js
 **/